import { render, staticRenderFns } from "./ManagementMappingLog.vue?vue&type=template&id=62804ed7&scoped=true&"
import script from "./ManagementMappingLog.vue?vue&type=script&lang=ts&"
export * from "./ManagementMappingLog.vue?vue&type=script&lang=ts&"
import style0 from "./ManagementMappingLog.vue?vue&type=style&index=0&id=62804ed7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62804ed7",
  null
  
)

export default component.exports